import globalStore from '@/services/global.state';
import {errorLog, getUrlParams, goTo} from '@utils';
import {SafeAny} from '@types';
import i18n from '@/i18n';
import {getSlotegratorGameStart, postUserInfo} from '@/services/global.service';
import {
  QueryCustomerOrderParams,
  postGenerateChatUrl,
  postQueryCustomerOrder,
} from '@/services/customer-service.service';
import {postLiveAuthorize} from '@/common-pages/game-navigate';
import {Linking} from 'react-native';
import {homePage} from '@/config';
import {inGameBox, openURL, openURLInAPP} from './interface';
import {getH5MigrationMode, H5_MIGRATION_CHAT_PATH} from './h5-migration';
import {getChannelApk} from '@/app.service';

declare var window: any;

export function postMessage(data: SafeAny) {
  if (globalStore.isWeb && window.top) {
    window.top.postMessage(
      data,
      getUrlParams(window.location.href).topwindowurl,
    );
  }
}

function isExternalHost(url: string) {
  const externalHosts = [
    't.me',
    'whatsapp.com',
    'nimble.li',
    'api.whatsapp.com',
    'm.youtube.com',
    'chat.whatsapp.com',
  ];
  return externalHosts.includes(new URL(url).host);
}

export function navigateTo(url: string) {
  if (inGameBox && isExternalHost(url)) {
    openURL(url);
    return;
  }
  if (globalStore.isWeb) {
    if (window.top) {
      window.top.location.href = url;
    } else {
      window.location.href = url;
    }
  } else {
    goTo('WebView', {
      nav: false,
      originUrl: url,
    });
  }
}

export const handleToLive = () => {
  navigateTo('https://m.youtube.com/@raajdhanilottery');
};

export function navigateGame(gameName: string, link: string) {
  const homeUrlSpell = globalStore.isWeb
    ? `homeurl=${window.location.origin}/index/casino`
    : '';

  const url = `${link}${
    link.indexOf('?') === link.length - 1
      ? ''
      : link.endsWith('cert=')
      ? ''
      : '&cert='
  }${globalStore.token}&${homeUrlSpell}`;

  goTo('WebView', {
    header: true,
    hideAmount: true,
    headerTitle: gameName,
    originUrl: url,
  });
}

export async function toLiveCasino(
  baseUrl: string,
  table: string,
  name?: string,
) {
  let url = baseUrl;
  if (url.lastIndexOf('?') === -1) {
    url = `${url}?`;
  }
  if (url.lastIndexOf('?') !== url.length - 1) {
    url = `${url}&`;
  }
  try {
    globalStore.globalLoading.next(true);
    const [userInfo, authorize] = await Promise.allSettled([
      postUserInfo(),
      postLiveAuthorize(),
    ]);
    if (userInfo.status === 'fulfilled' && authorize.status === 'fulfilled') {
      const uinfo = userInfo.value;
      const auth = authorize.value;
      url = `${url}token=${auth.authorize}&username=${
        uinfo.userPhone
      }&mobile=true&lobby=A8870&lang=${
        globalStore.lang
      }&options=defaulttable=${table}${
        globalStore.channel !== 'h5' ? ',webview=1' : ''
      }`;
      goTo('WebView', {
        header: true,
        hideAmount: true,
        headerTitle: name || i18n.t('home.live-casino.title'),
        originUrl: url,
      });
    } else {
      errorLog('error', userInfo, authorize);
    }
  } finally {
    setTimeout(() => {
      globalStore.globalLoading.next(false);
    }, 500);
  }
}

export async function toSlotegrator(name: string, id: string) {
  globalStore.globalLoading.next(true);
  try {
    const url = await getSlotegratorGameStart(id);
    goTo('WebView', {
      header: true,
      hideAmount: true,
      headerTitle: name,
      originUrl: url,
    });
  } finally {
    setTimeout(() => {
      globalStore.globalLoading.next(false);
    }, 500);
  }
}

export async function goSmartCS(params: QueryCustomerOrderParams = {}) {
  const orderNo =
    typeof params.orderNo === 'string' ? params.orderNo.trim() : '';

  if (!params.type || !orderNo) {
    errorLog('goSmartCS missing params', params);
    return;
  }

  let chatWindow: SafeAny = null;
  const shouldUseAppBridge =
    globalStore.isWeb && (inGameBox || !!window?.jsBridge || !!window?.Android);

  if (globalStore.isWeb && !shouldUseAppBridge) {
    chatWindow = window.open('', '_blank');
  }

  globalStore.globalLoading.next(true);
  try {
    const orderId = await postQueryCustomerOrder({orderNo, type: params.type});

    if (!orderId) {
      if (chatWindow && !chatWindow.closed) {
        chatWindow.close();
      }
      errorLog('goSmartCS empty orderId', params);
      return;
    }

    const chatUrl = await postGenerateChatUrl({
      type: params.type,
      orderId,
    });

    if (typeof chatUrl === 'string' && chatUrl) {
      if (shouldUseAppBridge) {
        if (window?.jsBridge) {
          openURL(chatUrl);
        } else if (window?.Android?.openURL) {
          openURLInAPP(chatUrl);
        }
        return;
      }

      if (globalStore.isWeb) {
        if (chatWindow) {
          chatWindow.location.href = chatUrl;
          chatWindow.focus?.();
        } else {
          window.open(chatUrl, '_blank');
        }
        return;
      }

      Linking.openURL(chatUrl);
      return;
    }

    if (chatWindow && !chatWindow.closed) {
      chatWindow.close();
    }
  } catch (error) {
    if (chatWindow && !chatWindow.closed) {
      chatWindow.close();
    }
    errorLog('goSmartCS query order or generateChatUrl', error);
  } finally {
    setTimeout(() => {
      globalStore.globalLoading.next(false);
    }, 300);
  }
}

/** 前往客服 */
export const goCS = () => {
  if (!globalStore.isWeb) {
    const chatModule = require('@components/chat');
    chatModule.Freshchat.showConversations(null);
    return;
  }
  if (
    typeof window !== 'undefined' &&
    getH5MigrationMode(window.location.pathname) === 'guide'
  ) {
    window.location.href = `${window.location.origin}${H5_MIGRATION_CHAT_PATH}`;
    return;
  }
  goTo(homePage, {
    screen: 'Chat',
  });
};

let downloadApkPromise: Promise<void> | null = null;

/** 从版本接口获取最新 APK 地址并触发浏览器下载。 */
export const downloadApk = () => {
  if (downloadApkPromise) {
    return downloadApkPromise;
  }

  globalStore.globalLoading.next(true);
  downloadApkPromise = getChannelApk()
    .then(versionInfo => {
      const downUrl = versionInfo?.downUrl?.trim();
      if (!downUrl) {
        globalStore.globalWaringTotal(i18n.t('download-unavailable'));
        return;
      }

      const a = document.createElement('a');
      a.href = downUrl;
      a.target = '_self';
      document.body.appendChild(a);
      a.click();
      a.remove();
    })
    .catch(error => {
      errorLog('获取 APK 下载地址失败:', error);
    })
    .finally(() => {
      globalStore.globalLoading.next(false);
      downloadApkPromise = null;
    });

  return downloadApkPromise;
};

export function toSports(gameName: string, link: string) {
  goTo('WebView', {
    header: true,
    hideAmount: false,
    headerTitle: gameName,
    originUrl: link,
  });
}
